import type { DeepPartial } from '@luna/utils-ts';

import type { InfoApiFeatureConfig } from '../type';

export const infoApi: DeepPartial<InfoApiFeatureConfig> = {
    fetchInstitutes: true,
};
